import { render } from "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=template&id=69a2820d&scoped=true"
import script from "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeRemoveBulkOnboardComponent.vue?vue&type=style&index=0&id=69a2820d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a2820d"]])

export default __exports__